var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.2344C18.6145 16.2344 20.734 14.1071 20.734 11.4829C20.734 8.85875 18.6145 6.73145 16 6.73145C13.3855 6.73145 11.266 8.85875 11.266 11.4829C11.266 14.1071 13.3855 16.2344 16 16.2344ZM16 16.9621C21.6712 16.9621 26.2686 21.5765 26.2686 27.2686C26.2686 27.2686 23.2189 31.9229 15.8284 31.9229C8.43787 31.9229 5.73145 27.2686 5.73145 27.2686C5.73145 21.5765 10.3288 16.9621 16 16.9621Z",
    fill: "#00A8CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9793 16.9617C30.9793 25.2704 24.2696 31.9996 16.0004 31.9996C7.73125 31.9996 1.02148 25.2704 1.02148 16.9617C1.02148 8.65305 7.73125 1.92383 16.0004 1.92383C24.2696 1.92383 30.9793 8.65305 30.9793 16.9617Z",
    stroke: "#00A8CD",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.aed01d0662a400de572fbe57df7fdefb.svg";
export { ForwardRef as ReactComponent };